
import React from 'react';
import TextEditor from '../../../Editor/Editor';

const AddNote = ({data, onAddNote, onSetNote}) => 
<div className='popupBg'>
<div className='popupMain'>
  <div className='popupHeader'>
    Add Notes
  </div>
  <div className='popupContent'>
  <div class style={{ border: '0.1rem solid rgba(83, 83, 83, 0.25)', borderRadius:'5px', padding:'0px', marginBottom: 25 }} className="input__control">
      <TextEditor
          editorState={data.note}
          onEditorStateChange={editorState => onSetNote(editorState)}
          placeholder={'Description'}
      />
    </div>
  </div>
  <div className='popupFooter'>
    <div class="addNoteButton">
      <button class="save" onClick={() => onAddNote('save')} disabled={!data.convertedNote}>Save</button> 
      <button class="close" onClick={() =>onAddNote('close')}>Close</button>
      </div>
  </div>
</div>
</div>

export default AddNote;